module.exports = __webpack_public_path__ + "static/media/login_bg.8d5f808.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/common/files/login_bg.mp4
// module id = 9R8D
// module chunks = 38